import { useProfile } from './useProfile';
import { Envinronments } from '@/sidebar/domain/constants';
import { useDashboardFlow } from './useDashboardFlow';

export const useFlags = () => {
  const profile = useProfile();
  const currentEnvironment = process.env.NODE_ENV as Envinronments;

  const { isDashboardEnabled } = useDashboardFlow(
    profile?.source,
    currentEnvironment,
  );

  return { isDashboardEnabled };
};
